module.exports = __webpack_public_path__ + "assets/img/Coolabah-Turf-Service-Page-w960.e9a416f4.jpg";